<!-- @format -->

@if (attainment) {
  <sis-expandable
    [closed]="false"
    [title]="'STUDENT_APPLICATIONS.MODULE_ATTAINMENT_APPLICATION_ATTAINMENT.MODULE_COMPLETION_INFO_TITLE' | translate">
    <ng-template sisExpandableContent>
      @if (!attainment.misregistration) {
        <sis-module-attainment [attainment]="attainment" [attainments]="attainments" [viewOptions]="viewOptions"> </sis-module-attainment>
      }
      @if (attainment.misregistration) {
        <div translate> PROFILE.ATTAINMENT.MISREGISTERED_ATTAINMENT </div>
      }
    </ng-template>
  </sis-expandable>
}
